import {axiosInstance} from "@/plugins/axios";
import {PurchaseAgreementFilter, PurchaseFilter} from "@/modules/purchase/types";

export async function getPurchase(id: string) {
  const response = await axiosInstance.get(`purchases/${id}`);
  return response.data;
}

export async function getPurchases(payload: PurchaseFilter) {

  let url = `purchases?start_date=${payload.start_date}&end_date=${payload.end_date}&offset=${payload.offset}&limit=${payload.limit}`;

  if (payload.field === "MATERIAL" && payload.search && payload.search !== "") {
    url += `&material=${payload.search}`
  }

  if (payload.undeclared) {
    url += `&undeclared=${payload.undeclared}`;
  }

  if (payload.id_agreement_group && payload.id_agreement_group > 0) {
    url += `&id_agreement_group=${payload.id_agreement_group}`;
  }

  if (payload.id_purchase) {
    url += `&id_purchase=${payload.id_purchase}`;
  }

  const response = await axiosInstance.get(url);
  return response.data;
}

export async function getPurchasesAgreements(payload: PurchaseAgreementFilter) {
  let url = `purchases/agreements?start_date=${payload.start_date}&end_date=${payload.end_date}&id_supplier=${payload.id_supplier}&`;

  if (payload.id_agreement_group && payload.id_agreement_group > 0) {
    url += `id_agreement_group=${payload.id_agreement_group}&`;
  }

  if (payload.id_purchases && payload.id_purchases.length > 0) {
    payload.id_purchases.forEach(item => {
      url += `id_purchases=${item}&`;
    });
  }

  const response = await axiosInstance.get(url);
  return response.data;
}
